import { render, staticRenderFns } from "./DepositDetailFooter.vue?vue&type=template&id=c74e56f0&scoped=true&"
import script from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DepositDetailFooter.vue?vue&type=style&index=0&id=c74e56f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74e56f0",
  null
  
)

export default component.exports